import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import Utils from './../Utils';
import ReferenceDetail from './ReferenceDetail';

const DETAIL_BG_SATURATION_PCT = 22;
const DETAIL_BG_LUMINANCE_PCT = 95;
const DETAIL_WIDTH_PCT = 100 / (2 * Utils.PHI);
const DETAIL_FADE_IN_MS = 150;
const DETAIL_FADE_OUT_MS = 250;
const DETAIL_BACKGROUND_ALPHA = 50;
const DETAIL_OPACITY = 92;

const ReferenceWrapper = styled.div`    
    position: fixed;
    opacity: 0.90;
    width: ${DETAIL_WIDTH_PCT}%;
    top: 4.65rem;
    left: -${DETAIL_WIDTH_PCT}%;
    height: auto;
    border-bottom-right-radius: 0.5rem;
    opacity: 0;
    z-index:150;
    box-shadow: 0.5rem 0.5rem 2rem rgba(0,0,0,60%);    
    background: linear-gradient(to bottom right, rgba(0,0,0,30%), rgba(0,0,0,0));
`;

const OpaqueBackground = styled.div`
    background: rgba(0,0,0,0);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index:149;
`;

export class ReferenceController extends Component {

    static propTypes = {
        reference_title: PropTypes.string.isRequired,
        reference_data: PropTypes.object.isRequired,
        on_close_reference: PropTypes.func.isRequired,
    }

    state = {
        background_ref: React.createRef(),
        detail_ref: React.createRef()
    };

    componentDidMount() {
        const {background_ref, detail_ref} = this.state;
        Utils.animate(background_ref, DETAIL_FADE_IN_MS, 0.0, 1.0, (value, is_last) => {
            background_ref.current.style.background = `rgba(0,0,0,${DETAIL_BACKGROUND_ALPHA * value}%)`;
            detail_ref.current.style.opacity = `${DETAIL_OPACITY * value}%`;
            detail_ref.current.style.left = `-${DETAIL_WIDTH_PCT * (1.0 - value)}%`;
        });
        document.addEventListener('click', this.clear_reference);
        document.addEventListener("keydown", ({key}) => this.key_listener(key));
    }

    key_listener = (key) => {
        if (key === "Escape") {
            this.clear_reference();
        }
    }

    clear_reference = () => {
        const {background_ref, detail_ref} = this.state;
        const {on_close_reference} = this.props;
        Utils.animate(background_ref, DETAIL_FADE_OUT_MS, 1.0, 0.0, (value, is_last) => {
            background_ref.current.style.background = `rgba(0,0,0,${DETAIL_BACKGROUND_ALPHA * value}%)`;
            detail_ref.current.style.opacity = `${DETAIL_OPACITY * value}%`;
            detail_ref.current.style.left = `-${DETAIL_WIDTH_PCT * (1.0 - value)}%`;
            if (is_last) {
                on_close_reference()
            }
        });
        document.removeEventListener('click', this.clear_reference);
    }

    render() {
        const {background_ref, detail_ref} = this.state;
        const {reference_title, reference_data} = this.props;

        const wrapper_style = {
            backgroundColor: `hsl(${reference_data.hue}, ${DETAIL_BG_SATURATION_PCT}%, ${DETAIL_BG_LUMINANCE_PCT}%)`,
        }
        return <OpaqueBackground ref={background_ref}>
            <ReferenceWrapper ref={detail_ref} style={wrapper_style}>
                <ReferenceDetail reference_title={reference_title} reference_data={reference_data}/>
            </ReferenceWrapper>
        </OpaqueBackground>
    }
}

export default ReferenceController;
